import script from "./CookieBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./CookieBar.vue?vue&type=script&lang=ts&setup=true"

import "./CookieBar.vue?vue&type=style&index=0&id=6025574d&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6025574d"]])

export default __exports__